module.exports = __webpack_public_path__ + "media/scott.e623eed0.mp4";